import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState } from "react";

export default function Banner(props: any) {
    const { section = "home" } = props;
    const [data, setData] = useState<any>(null);
    const [visible, setVisible] = useState(false);

    const loadData = () => {
        ApiRequest({
            url: '/banners/getBanner',
            method: 'GET',
            query: { section },
            setResponse: (response: any) => {
                if (response.status === 'success' && response.image) {
                    setData(response);
                    setVisible(true);
                }
            }
        });
    };

    useEffect(() => {
        loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section]);

    if (!data?.image || !visible) return null;

    const hasOverlay = data.title || data.subtitle || data.button_text;

    const cardContent = (
        <div style={{ position: 'relative', lineHeight: 0 }}>
            {/* Close button */}
            <button
                onClick={e => { e.preventDefault(); e.stopPropagation(); setVisible(false); }}
                style={{
                    position: 'absolute',
                    top: -16,
                    right: -16,
                    zIndex: 10,
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
                    fontSize: 18,
                    color: '#333',
                    lineHeight: 1,
                    fontWeight: 700,
                    transition: 'background 0.15s',
                }}
                onMouseEnter={e => (e.currentTarget.style.background = '#f0f0f0')}
                onMouseLeave={e => (e.currentTarget.style.background = '#fff')}
                aria-label="Cerrar"
            >
                ✕
            </button>

            {/* Banner image */}
            <img
                src={data.image}
                alt="banner"
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    borderRadius: 16,
                }}
            />

            {/* Overlay text */}
            {hasOverlay && (
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    padding: 'clamp(16px, 5%, 48px)',
                    background: 'linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 60%, transparent 100%)',
                }}>
                    {data.title && (
                        <h2 style={{
                            color: '#fff',
                            margin: '0 0 8px 0',
                            fontSize: 'clamp(16px, 3vw, 32px)',
                            fontWeight: 700,
                            lineHeight: 1.2,
                            textShadow: '0 2px 8px rgba(0,0,0,0.4)',
                            maxWidth: '60%',
                        }}>
                            {data.title}
                        </h2>
                    )}
                    {data.subtitle && (
                        <p style={{
                            color: 'rgba(255,255,255,0.92)',
                            margin: '0 0 20px 0',
                            fontSize: 'clamp(12px, 1.5vw, 17px)',
                            lineHeight: 1.5,
                            textShadow: '0 1px 4px rgba(0,0,0,0.4)',
                            maxWidth: '55%',
                        }}>
                            {data.subtitle}
                        </p>
                    )}
                    {data.button_text && (
                        <span style={{
                            display: 'inline-block',
                            background: '#fff',
                            color: '#005F6A',
                            fontWeight: 700,
                            fontSize: 'clamp(12px, 1.2vw, 15px)',
                            padding: '10px 24px',
                            borderRadius: '50px',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                            cursor: 'pointer',
                            letterSpacing: '0.3px',
                        }}>
                            {data.button_text}
                        </span>
                    )}
                </div>
            )}
        </div>
    );

    return (
        /* Backdrop */
        <div
            onClick={() => setVisible(false)}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 1200,
                background: 'rgba(0,0,0,0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                animation: 'bannerFadeIn 0.25s ease',
            }}
        >
            {/* Card — stop propagation so clicking the card doesn't close */}
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    width: '100%',
                    maxWidth: 680,
                    position: 'relative',
                    borderRadius: 16,
                    boxShadow: '0 24px 80px rgba(0,0,0,0.45)',
                    animation: 'bannerSlideUp 0.28s cubic-bezier(0.34,1.56,0.64,1)',
                }}
            >
                {data.url ? (
                    <a href={data.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', textDecoration: 'none' }}>
                        {cardContent}
                    </a>
                ) : cardContent}
            </div>

            <style>{`
                @keyframes bannerFadeIn {
                    from { opacity: 0; }
                    to   { opacity: 1; }
                }
                @keyframes bannerSlideUp {
                    from { opacity: 0; transform: scale(0.92) translateY(16px); }
                    to   { opacity: 1; transform: scale(1) translateY(0); }
                }
            `}</style>
        </div>
    );
}
